/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Password_MinInputs */

const en_password_reset_password_min = /** @type {(inputs: Password_Reset_Password_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password must be at least 8 characters`)
};

const es_password_reset_password_min = /** @type {(inputs: Password_Reset_Password_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La contraseña debe tener al menos 8 caracteres`)
};

/**
* | output |
* | --- |
* | "Password must be at least 8 characters" |
*
* @param {Password_Reset_Password_MinInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_password_min = /** @type {((inputs?: Password_Reset_Password_MinInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Password_MinInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_password_min(inputs)
	return en_password_reset_password_min(inputs)
});